import { useState, useEffect } from "react";
import { useStyletron } from "baseui";

interface DeviceTypes {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

const useDeviceType = (): DeviceTypes => {
  const [, theme] = useStyletron();
  const [deviceTypes, setDeviceTypes] = useState(getDeviceTypes(theme.breakpoints));

  useEffect(() => {
    const handleResize = () => {
      setDeviceTypes(getDeviceTypes(theme.breakpoints));
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [theme.breakpoints]);

  return deviceTypes;
};

const getDeviceTypes = (breakpoints: { medium: number; large: number }): DeviceTypes => {
  const windowWidth = window.innerWidth;

  return {
    isMobile: windowWidth < breakpoints.medium,
    isTablet: windowWidth >= breakpoints.medium && windowWidth < breakpoints.large,
    isDesktop: windowWidth >= breakpoints.large,
  };
};

export default useDeviceType;
